import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function PeriodButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faCalendar} />}
      color="secondary"
    />
  );
}

PeriodButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

PeriodButton.defaultProps = {
  content: 'Змінити період перегляду',
  disabled: false,
};

export default PeriodButton;
